import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IPostList {
    type?: 'post' | 'announce' | string
    category?: string
    channel?: string
    comments_count?: number
    content?: string
    created_at?: number
    guild_id?: string
    id?: string
    images?: string[]
    language?: string
    likes_count?: number
    title?: string
    user?: {
        id: string
        name: string
        thumbnail: string
        is_filtered?: boolean
    }
    user_id?: string
    visibility?: number
}

export const getPostList = async (
    size: number,
    current_page: number = 1,
    search_word: string = '',
    search_id: string = '',
): Promise<ApiRes<IPostList[]>> => {
    return await apiGet(
        API_URL,
        `admin/posts?page_size=${size}&current_page=${current_page}&search_word=${search_word}&search_id=${search_id}`,
    )
}
